import homeApi from "../../../api/home/home";

const state = {
  list: {}
};

const getters = {};

const mutations = {
  // 存首页的列表
  setList(state, { data }) {
    state.list = data;
  },
  // 修改收藏状态
  collect(state, { data }) {
    state.list.list.find(v => {
      if (v.propertyId == data.id) {
        if (data.type == "no") {
          v.favoritesFlag = "yes";
        } else {
          v.favoritesFlag = "no";
        }
      }
    });
  }
};

const actions = {
  getAds({ state }, { params, callback }) {
    console.log(state);
    homeApi.getAdsApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取首页列表
  getList({ state }, { params, callback }) {
    console.log(state);
    homeApi.getListApi({ params, callback }, res => {
      callback(res);
    });
  },

  getSearchSuburbsDropdown({ state }, { params, callback }) {
    console.log(state);
    homeApi.getSearchSuburbsDropdownApi({ params, callback }, res => {
      callback(res);
    });
  },
  getAllStates({ state }, { params, callback }) {
    console.log(state);
    homeApi.getAllStatesApi({ params, callback }, res => {
      callback(res);
    });
  },

  // 收藏
  postCollect({ state }, { params, callback }) {
    console.log(state);
    homeApi.postCollectApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 取消收藏
  cancelCollect({ state }, { params, callback }) {
    console.log(state);
    homeApi.cancelCollectApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 签名的
  sign({ state }, { params, callback }) {
    console.log(state);
    homeApi.signApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 同意协议
  agree({ state }, { param, callback }) {
    console.log(state);
    homeApi.agreeApi({ param, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/home/home.js